import type { ComponentProps } from "react"

export type LogoProps = ComponentProps<"svg">

// Wordmark-less Placepoint glyph. Same paths as v2-backoffice-client
// so customers visiting both surfaces see the same brand mark; kept
// local to this app rather than promoted to v2-ui to avoid forcing
// every consumer to depend on a brand asset they may not need.
function Logo(props: Readonly<LogoProps>) {
  const { width = 110, height = 147, ...svgProps } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 110 147"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path d="M0 26.3V126.7L33.7 146.1L39.6 142.7V42.3L5.9 22.8L0 26.3Z" />
      <path d="M45.5 0L39.6 3.39999V42.3L69.6 59.6V103.3L75.5 106.7L109.2 87.2V36.8L45.5 0Z" />
    </svg>
  )
}

export default Logo
